import { render, staticRenderFns } from "./DetalleSaldo.vue?vue&type=template&id=789343f4&scoped=true"
import script from "./DetalleSaldo.vue?vue&type=script&lang=ts"
export * from "./DetalleSaldo.vue?vue&type=script&lang=ts"
import style0 from "./DetalleSaldo.vue?vue&type=style&index=0&id=789343f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789343f4",
  null
  
)

export default component.exports